import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";

export class BookOfShadowsSymbolsWinAnimations extends BaseView {
    private _symAnims: TimelineSprite[][] = [];
    private _layer: ScalableLayer;
    private _numOfRows: number = 5;
    private _numOfCols: number = 5;

    /**
     * @description To play the symbol animation.
     * @param reelId
     * @param symId
     * @param symbol
     * @param isToggling
     */
    public playAnimation(reelId: number, symId: number, symbol: StateReelSymbol, isToggling: boolean = false): Timeline {
        let tl: Timeline = new TimelineLite(),
            state: ISymbolStateConfig;

        const gameConfigInstance: BookOfShadowsGameConfig = BookOfShadowsGameConfig.instance,
            symName: string = symbol.symName;

        if ((isToggling && symName !== "S") || (symName.indexOf("L") !== -1)) {
            tl.add(this._symAnims[reelId][symId].getAnimationAutoShowHide(), 0);
        } else if ((isToggling && symName === "S")) {
            state = gameConfigInstance.SYMBOL_STATES.winToggle;
            tl.add(symbol.changeState({
                state: state,
                fadeInDuration: 0.2
            }));
        } else {
            // #42
            if (symName === gameConfigInstance.FS_SPECIAL_SYMBOL) {
                state = gameConfigInstance.SYMBOL_STATES.goldWin;
            } else {
                state = gameConfigInstance.SYMBOL_STATES.win;
            }

            tl.add(symbol.changeState({
                state: state,
                fadeInDuration: ((symName.indexOf("M") > -1) ? 0.2 : 0)
            }));
        }

        return tl;
    }

    /**
     * @description To stop all the animations.
     */
    public stopAllAnimation(): void {
        for (let i: number = 0; i < this._numOfCols; ++i) {
            for (let j: number = 0; j < this._numOfRows; ++j) {
                this._symAnims[i][j].hide();
                this._symAnims[i][j].stopLoop();
            }
        }
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        this._layer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.SYMBOLS_WIN_ANIM.name);
        this._layer.addChild(this);

        let symAnim: TimelineSprite,
            pos: number[];

        for (let i: number = 0; i < this._numOfCols; ++i) {
            this._symAnims.push([]);
            for (let j: number = 0; j < this._numOfRows; ++j) {
                pos = Helper.getSymbolPositions(i, j);

                symAnim = new TimelineSprite(GameResources.getTextures("lSymWinAnim"));
                symAnim.hide();
                symAnim.anchor.set(0.5);
                symAnim.blendMode = PIXI.BLEND_MODES.ADD;
                symAnim.position.set(pos[0], pos[1]);

                this.addChild(symAnim);
                this._symAnims[i].push(symAnim);
            }
        }
    }
}